import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Brightness4, Brightness7 } from '@mui/icons-material';
import { useTheme } from '../../context/ThemeContext';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <Tooltip
      title={isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
      slotProps={{
        tooltip: {
          sx: {
            backgroundColor: 'var(--color-surface)',
            color: 'var(--color-text-primary)',
            border: '1px solid var(--color-border-primary)',
            fontSize: 'var(--font-size-sm)',
            boxShadow: 'var(--shadow-md)',
          }
        }
      }}
    >
      <IconButton
        onClick={toggleTheme}
        sx={{
          color: 'var(--color-text-primary)',
          padding: 'var(--spacing-sm)',
          borderRadius: 'var(--radius-md)',
          transition: 'var(--transition-fast)',
          '&:hover': {
            backgroundColor: 'var(--color-surface-hover)',
          },
          '&:active': {
            backgroundColor: 'var(--color-surface-active)',
          },
        }}
        aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      >
        {isDark ? <Brightness7 /> : <Brightness4 />}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggle;
